<template>
  <camoodoo-page icon="help_outline" title="Frequently asked questions">
    <simple-section dark title="I can't connect to camera">
      Please try the following steps:
      <ul>
        <li>
          Ensure no other App or Device is connected to your camera in
          Background.
        </li>
        <li>
          Install newest Version of Smart Remote Control app on your Camera (see
          <a
            href="https://www.playmemoriescameraapps.com/portal/usbdetail.php?eid=IS9104-NPIA09014_00-F00002"
            >Playmemories Smart Remote Control</a
          >).
        </li>
        <li>
          Delete the Wifi-Network of the camera in the Wifi-Settings of Android.
          Then recreate it with Camoodoo (e.G. by scanning QR-Code)
        </li>
        <li>
          Install newest Firmware of your camera. (on A9 the V5+ Firmware
          currently does not work with Camoodoo).
        </li>
        <li>Deactivate Mobile Data during usage of the app.</li>
        <li>
          Disable AdBlockers, VPNs or other Apps that may have influence to
          Network traffic. Camoodoo is not generally incompatible with such Apps
          but maybe they are not configured properly for usage with Camoodoo.
        </li>
        <li>Sometimes a restart of your Camera is required.</li>
      </ul>
    </simple-section>
    <simple-section
      light
      title="The Liveview is always blue and/or I can't
        change any camera settings"
    >
      This happens on older cameras. When the cameras supports Apps via
      Playmemories (like A6000/A6300) then install latest Version of Smart
      Remote Control app on your Camera (see
      <a
        href="https://www.playmemoriescameraapps.com/portal/usbdetail.php?eid=IS9104-NPIA09014_00-F00002"
        >Playmemories Smart Remote Control</a
      >).
    </simple-section>
    <simple-section dark title="Camoodoo does not start or has a weird layout">
      Camoodoo depends on the Webview Component which is provided by Google as
      an separate App. This component is already installed on your Device and is
      normally updated automatically. In some cases the automatic update seems
      to be deactivated. Please check if you have the current version by
      searching in Google Play for
      <a
        href="https://play.google.com/store/apps/details?id=com.google.android.webview"
        >Android System WebView</a
      >
      and update it if required.
    </simple-section>
    <simple-section
      light
      title="I bought the Pro version but it is still not activated"
    >
      Normally the Pro version is immediately activated after purchase. In some
      cases (especially when the payment process makes trouble) it is not
      directly activated after the pruchase. Camoodoo checks on each start the
      bought products when there is access to the internet. In some rare cases
      you need to reinstall the app.
    </simple-section>
    <simple-section
      dark
      title="Can I use the Pro version also on other devices?"
    >
      The purchase is connected to your Google Play account and Camoodoo
      automatically switches to the Pro Version on any device connected to your
      account
    </simple-section>
  </camoodoo-page>
</template>

<script>
import CamoodooPage from "@/components/CamoodooPage.vue";
import SimpleSection from "../../sections/SimpleSection.vue";

export default {
  components: {
    CamoodooPage,
    SimpleSection,
  },
};
</script>

<style lang="scss" scoped></style>
